import { ActivatedRoute, convertToParamMap, Params } from '@angular/router';
import { ApiQuery, COMPLETABLE_TASK_FACET, QueryPart } from '@stylehaven/components';

const SPECIAL_QUERY_PARAMS: string[] = ['advQ', 'page', 'size', 'overview', COMPLETABLE_TASK_FACET, 'f'];

/**
 * @deprecated Do not use further
 * @param route
 * @returns
 */
export const GetGlobalAndFacetsFromActivatedRoute: (route: ActivatedRoute) => QueryPart[] = (
    route: ActivatedRoute
): QueryPart[] => {
    const qp = ApiQuery.fromQueryParam(route.snapshot.queryParamMap).filter(
        qp => !SPECIAL_QUERY_PARAMS.includes(qp.field)
    );

    return qp;
};

/**
 * @deprecated Do not use further
 * @param params
 * @returns
 */
export const GetGlobalAndFacetsFromParams: (params: Params) => QueryPart[] = (params: Params): QueryPart[] => {
    const filteredQueryParts = ApiQuery.fromQueryParam(convertToParamMap(params)).filter(
        qp => !SPECIAL_QUERY_PARAMS.includes(qp.field)
    );
    return filteredQueryParts;
};
